import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import service from '../service';
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { newSupplierRegisterDetailReportSchema } from "../newSupplierRegisterDetailReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';
import TableCell from '@material-ui/core/TableCell';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';

const screenCode = "NEWSUPPLIERREGISTERDETAILREPORT";

export function NewSupplierRegisterDetailReport(props) {

    const componentRef = useRef();
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [supplierRegistrationDetails, setSupplierRegistrationDetails] = useState([]);
    const [supplierRegistrationDetailsInputs, setSupplierRegistrationDetailsInputs] = useState({
        fromDate: "",
        toDate: ""
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(newSupplierRegisterDetailReportSchema).options({ allowUnknown: true });

    const csvHeaders = [
        { label: "Reg No", value: "customerCode" },
        { label: "Reg Name", value: "firstName" },
        { label: "RCode", value: "collectionPointCode" },
        { label: "Route Name", value: "collectionPointName" },
        { label: "Dy No", value: "mobileNo", render: rowData => rowData.mobileNo == null ? '-' : rowData.mobileNo },
        { label: "Address", value: "address1" },
    ];

    useEffect(() => {
        trackPromise(getPermissions(),
        );
    }, []);

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, newSupplierRegisterDetailReportSchema);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {

        e.preventDefault();
        setButtonHide(true);
        const errorMessages = validate(schema, supplierRegistrationDetailsInputs);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const response = await service.getRegisterSupplierDetails(supplierRegistrationDetailsInputs);
        setSupplierRegistrationDetails(response)
        setCsvData(response);
    }

    function handleSearchFromDateChange(target) {
        validateInputs(target);

        setSupplierRegistrationDetailsInputs({
            ...supplierRegistrationDetailsInputs,
            fromDate: target.value,
        });
    }

    function handleSearchToDateChange(target) {
        validateInputs(target);

        setSupplierRegistrationDetailsInputs({
            ...supplierRegistrationDetailsInputs,
            toDate: target.value,
        });
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWNEWREGISTERSUPPLIERDETAILREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();
    }

    function createFile() {
        var settings = {
            sheetName: 'Supplier Reg Detail Report',
            fileName: 'SupplierRegistrationDetailReport',
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(supplierRegistrationDetails)

        var newRow1 = {
            customerCode: "From Date : " + supplierRegistrationDetailsInputs.fromDate,
        }
        var newRow2 = {
            customerCode: "To Date : " + supplierRegistrationDetailsInputs.toDate,
        }
        copyOfCsv.push({}, {}, newRow1, newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Supplier Registration Detail Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleSearchFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-6">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleSearchToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>
                            {supplierRegistrationDetails.length != 0 ?
                                <div style={{ width: '1400px' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Reg No
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Reg Name
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        RCode
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Route Name
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Dy No
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Address
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {supplierRegistrationDetails.slice(page * limit, page * limit + limit).map((row, i) => (
                                                                    <TableRow key={row.divisionID}>
                                                                        <TableCell component="th" align="center" >
                                                                            {row.customerCode == null ? '-' : row.customerCode}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.firstName == null ? '-' : row.firstName}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.collectionPointCode == null ? '-' : row.collectionPointCode}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.collectionPointName == null ? '-' : row.collectionPointName}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.mobileNo == null ? '-' : row.mobileNo}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.address1 == null ? '-' : row.address1}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                        <TablePagination
                                                            component="div"
                                                            count={supplierRegistrationDetails.length}
                                                            onChangePage={handlePageChange}
                                                            onChangeRowsPerPage={handleLimitChange}
                                                            page={page}
                                                            rowsPerPage={limit}
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                        />
                                                    </TableContainer>
                                                </Box>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                        {supplierRegistrationDetails.length != 0 ?
                            <div className="pt-2">
                                <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Excel"
                                    onClick={createFile}
                                />
                                <ReactToPrint
                                    documentTitle={"Supplier Registration Detail Report"}
                                    trigger={() => <input
                                        type="submit"
                                        className="btn btn-primary pull-right ml-2"
                                        value="PDF"
                                    />}
                                    content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef}
                                        supplierRegistrationDetails={supplierRegistrationDetails} supplierRegistrationDetailsInputs={supplierRegistrationDetailsInputs}
                                    />
                                </div>
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
